import script from "./RoomTopComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomTopComponent.vue?vue&type=script&setup=true&lang=js"

import "./RoomTopComponent.vue?vue&type=style&index=0&id=eaac214a&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eaac214a"]])

export default __exports__